import { useQuery } from "@tanstack/react-query";
import { getStravaActivityDetail } from "api-client";
import { Icon } from "icons";

import { StravaActivityLaps } from "./StravaActivityLaps";
import { StravaActivityZones } from "./StravaActivityZones";

interface StravaActivityDetailProps {
  stravaActivityId: string;
  workoutType: string;
}

export function StravaActivityDetail(props: StravaActivityDetailProps) {
  const query = useQuery({
    queryKey: ["strava-activity-detail", props.stravaActivityId],
    queryFn: () => {
      return getStravaActivityDetail({
        path: { id: props.stravaActivityId },
      });
    },
  });

  if (query.isLoading) {
    return (
      <div className="flex items-center justify-center py-4">
        <Icon
          name="tabler-loader-2"
          className="size-5 animate-spin text-muted-foreground"
        />
      </div>
    );
  }

  if (query.isError || !query.data) {
    return (
      <p className="text-xs text-muted-foreground py-2">
        Failed to load activity details.
      </p>
    );
  }

  const detail = query.data.data.data;

  return (
    <div className="space-y-4">
      <StravaActivityLaps laps={detail.laps} workoutType={props.workoutType} />
      <StravaActivityZones
        zones={detail.zones}
        zonesAvailable={detail.zonesAvailable}
      />
    </div>
  );
}
